const PREFIX = "tusmo_clone_";

function load(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

function save(key, value) {
  localStorage.setItem(PREFIX + key, JSON.stringify(value));
}

export function getModeState(mode) {
  return load("mode_" + mode) || {
    lastSolvedDay: null,
    streak: 0
  };
}

export function markSolved(mode, dayIndex) {
  const state = getModeState(mode);
  if (state.lastSolvedDay === dayIndex) {
    return state;
  }
  let newStreak = 1;
  if (state.lastSolvedDay !== null && dayIndex === state.lastSolvedDay + 1) {
    newStreak = state.streak + 1;
  }
  const newState = {
    lastSolvedDay: dayIndex,
    streak: newStreak
  };
  save("mode_" + mode, newState);
  return newState;
}
